import { render, staticRenderFns } from "./VoucherChips.vue?vue&type=template&id=210194d5&scoped=true&"
import script from "./VoucherChips.vue?vue&type=script&lang=js&"
export * from "./VoucherChips.vue?vue&type=script&lang=js&"
import style0 from "./VoucherChips.vue?vue&type=style&index=0&id=210194d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210194d5",
  null
  
)

component.options.__file = "VoucherChips.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
